import React from "react";
import { JSX } from "react/jsx-runtime";

const AddIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="75" height="78" viewBox="0 0 75 78" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="1.5" y="4.5" width="71.5032" height="72" rx="35.7516" fill="white" fill-opacity="0.8" stroke="#C8C8CA" stroke-width="3"/>
        <path d="M35.2671 55.017V26.892H40.0398V55.017H35.2671ZM23.591 43.3409V38.5682H51.716V43.3409H23.591Z" fill="#CDCDEC"/>
    </svg>
  );
};

export default AddIcon;


